import { Page } from '../../types'

const civilAction: Page[] = [
    {
        pageType: 'question',
        title: 'Civil action',
        name: 'civil-action',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'civil-action-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'civil-action-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'civil-action-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default civilAction
